export enum SalesTableColumnId {
  // Not Configurable
  Checkbox = 'checkbox',
  // Configurable
  Seating = 'seating',
  Row = 'row',
  Seats = 'seats',
  QuantitySold = 'quantitySold',
  OrderDate = 'orderDate',
  InHandDate = 'inHandDate',
  Status = 'status',
  TicketType = 'ticketType',
  Proceeds = 'proceeds',
  Sale = 'sale',
  Actions = 'actions',
  // Default Visibility Off (optional columns)
  SoldTicketCost = 'soldTicketCost',
  Charges = 'charges',
  Credits = 'credits',
  PandL = 'PandL',
  Margin = 'margin',
  PurchaseCreatedBy = 'purchaseCreatedBy',
  PurchasedBy = 'purchasedBy',
  PaymentState = 'paymentState',
  PaymentReceived = 'paymentReceived',
  PaymentReferenceId = 'paymentReferenceId',
  FulfillmentDate = 'fulfillmentDate',
  AutoFulfill = 'autoFulfill',
  PurchaseDate = 'purchaseDate',
  VendorOrderId = 'vendorOrderId',
  VendorAccountEmail = 'vendorAccountEmail',
  OriginatedBy = 'originatedBy',
  TotalPaymentsAmount = 'totalPaymentsAmount',
  TotalConvertedPaymentsAmount = 'totalConvertedPaymentsAmount',
  WastedQuantity = 'wastedQuantity',
  InternalNotes = 'internalNotes',
  SeatTraits = 'seatTraits',
  ConsigneeSellerAccountId = 'consigneeSellerAccountId',
}

export enum SalesTableFlattenedColumnId {
  Event = 'Event',
  Venue = 'Venue',
  Location = 'Location',
  EventDate = 'Date',
}

/**
 * Column id for home page 2.0 sales feed
 */
export enum RecentSalesTableColumnId {
  EventName = 'RecentSales_EventName',
  EventDate = 'RecentSales_EventDate',
  Seating = 'RecentSales_Seating',
  Marketplace = 'RecentSales_Marketplace',
  SoldQuantityTicketType = 'RecentSales_SoldQuantityTicketType',
  SaleId = 'RecentSales_SaleId',
  Proceeds = 'RecentSales_Proceeds',
  PandL = 'RecentSales_PandL',
  Margin = 'RecentSales_Margin',
  InHandDate = 'RecentSales_InHandDate',
  OrderDate = 'RecentSales_OrderDate',
  Venue = 'RecentSales_Venue',
  Status = 'RecentSales_Status',
  Actions = 'RecentSales_Actions',
}

export enum SalesReportTableColumnId {
  // Group by types
  Performer = 'performer',
  Venue = 'venue',
  Event = 'event',
  EventGenre = 'eventGenre',
  EventCountry = 'eventCountry',
  EventCity = 'eventCity',
  SeatingSection = 'seatingSection',
  SeatingRow = 'seatingRow',
  SaleMarketplace = 'saleMarketplace',
  SaleMonth = 'saleMonth',
  SaleWeek = 'saleWeek',
  SaleDay = 'saleDay',
  // Configurable - shared precision with ListingTableColumnId
  QuantitySold = SalesTableColumnId.QuantitySold,
  Proceeds = SalesTableColumnId.Proceeds,
  SoldTicketCost = SalesTableColumnId.SoldTicketCost,
  Charges = SalesTableColumnId.Charges,
  Credits = SalesTableColumnId.Credits,
  // Auxiliary columns - neither metrics nor primary dimensions
  EventId = 'eventId',
  Category = 'category',
  EventDate = 'eventDate',
  EventStateProvince = 'eventStateProvince',
  SaleId = 'saleId',
  MarketplaceSaleId = 'marketplaceSaleId',
  Status = SalesTableColumnId.Status,
  TicketType = SalesTableColumnId.TicketType,
  InHandDate = SalesTableColumnId.InHandDate,
  Fulfiller = 'fulfiller',
  PurchaseId = 'purchaseId',
  PurchasedBy = 'purchasedBy',
  PurchaseDate = SalesTableColumnId.PurchaseDate,
  Vendor = 'vendor',
  SeatingSeats = 'seatingSeats',
  OrderDate = SalesTableColumnId.OrderDate,
  PricedBy = 'pricedBy',
  CurrencyCode = 'currencyCode',
  PaymentDate = 'paymentDate',
  FulfillmentDate = SalesTableColumnId.FulfillmentDate,
  PurchaseCreatedBy = SalesTableColumnId.PurchaseCreatedBy,
  PaymentState = SalesTableColumnId.PaymentState,
  PaymentReceived = SalesTableColumnId.PaymentReceived,
  PaymentReferenceId = SalesTableColumnId.PaymentReferenceId,
  VendorAccountEmail = SalesTableColumnId.VendorAccountEmail,
  InternalNotes = 'internalNotes',
  CancellationDate = 'cancellationDate',
  OutstandingBalance = 'outstandingBalance',
  PandL = SalesTableColumnId.PandL,
  Margin = SalesTableColumnId.Margin,
  TicketId = 'ticketId',
  TicketGroupId = 'ticketGroupId',
  CommissionUser = 'commissionUser',
  CommissionPercent = 'commissionPercent',
  CommissionShare = 'commissionShare',
  MarketplacePaymentTerms = 'marketplacePaymentTerms',
}

// Subset of ReportSalesColumnName from ReportingService
export enum SalesReportTableGroupingColumnId {
  PerformerName = 'performerName',
  VenueName = 'venueName',
  EventName = 'eventName',
  TopLevelCategoryName = 'topLevelCategoryName',
  ParentCategoryName = 'parentCategoryName',
  CountryName = 'countryName',
  CityName = 'cityName',
  Section = 'section',
  SeatingRow = 'seatingRow',
  SeatFrom = 'seatFrom',
  SeatTo = 'seatTo',
  EventId = 'eventId',
  LocalEventDateTime = 'localEventDateTime',
  StateProvince = 'stateProvince',
  SaleId = 'saleId',
  InternalNotes = 'internalNotes',
  SaleDate = 'saleDate',
  SaleStatusName = 'saleStatusName',
  PaymentReferenceId = 'paymentReferenceId',
  TicketTypeName = 'ticketTypeName',
  InHandDate = 'inHandDate',
  LastPaymentDate = 'lastPaymentDate',
  CancellationDate = 'cancellationDate',
  FulfillerSellerUserId = 'fulfillerSellerUserId',
  FulfillmentDate = 'fulfillmentDate',
  MarketplacePaymentStateName = 'marketplacePaymentStateName',
  MarketplaceName = 'marketplaceName',
  MarketplaceSaleId = 'marketplaceSaleId',
  IsSeatSaver = 'isSeatSaver',
  IsNoFulfill = 'isNoFulfill',
  SaleWeek = 'saleWeek',
  SaleMonth = 'saleMonth',
  SaleDay = 'saleDay',
  PurchaseOrderId = 'purchaseOrderId',
  PurchaseOrderDate = 'purchaseOrderDate',
  BuyerUserId = 'buyerUserId',
  PurchaseOrderVendorName = 'purchaseOrderVendorName',
  VendorOrderId = 'vendorOrderId',
  VendorAccountEmail = 'encryptedEmailAddress',
  PurchaseOrderInsertBy = 'purchaseOrderInsertBy',
  EventStateName = 'eventStateName',
  PricerSellerUserId = 'pricerSellerUserId',
  PaymentReceived = 'paymentReceived',
  CurrencyCode = 'currencyCode',
  SaleCancellationReason = 'saleCancellationReason',
  ListingNoteTexts = 'listingNoteTexts',
  ListingId = 'listingId',
}

export enum SalesReportTableValueColumnId {
  QuantitySold = 'quantitySold',
  QuantityWasted = 'quantityWasted',
  TotalNetProceeds = 'totalNetProceeds',
  TotalPaymentAmount = 'totalPaymentAmount',
  Charges = 'charges',
  Credits = 'credits',
  OutstandingBalance = 'outstandingBalance',
  PandL = 'PandL',
  TotalCost = 'totalCost',
  Margin = 'margin',
  TotalNetProceedsSellerAccountCurrency = 'totalNetProceedsSellerAccountCurrency',
  ChargesSellerAccountCurrency = 'chargesSellerAccountCurrency',
  CreditsSellerAccountCurrency = 'creditsSellerAccountCurrency',
  TotalCostSellerAccountCurrency = 'totalCostSellerAccountCurrency',
  OutstandingBalanceSellerAccountCurrency = 'outstandingBalanceSellerAccountCurrency',
  PandLSellerAccountCurrency = 'pandLSellerAccountCurrency',
}

export const SALES_REPORT_TABLE_FORMULA_COLUMNS: SalesReportTableValueColumnId[] =
  Object.values(SalesReportTableValueColumnId);
